import {
  ChoiceGroup,
  DatePicker,
  DefaultButton,
  Icon,
  Label,
  Panel,
  PanelType,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import { useCallback } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import { ComboBoxIDS } from "../../../../components/generic/ComboBoxIDS";
import { useComboSupervisores } from "../../../../hooks/combosHooks/useComboSupervisores";
import { useComboEstados } from "../../../../hooks/combosHooks/useComboEstados";
import { useComboTipoEquipo } from "../../../../hooks/combosHooks/useComboTipoEquipo";
import { useComboModelos } from "../../../../hooks/combosHooks/useComboModelos";
import { useComboEquipos } from "../../../../hooks/combosHooks/useComboEquipos";
import { onFormatDate } from "../../../../utils/helpers/dateHelpers";
import { IRequetTableHistoricoPorSupervisor } from "../../../../Interfaces/IListaVerificacion";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";

interface IPanelSupervisorHistorial {
  isOpen: boolean;
  onDismiss: () => void;
  onChangeComboBox: (e, o, string) => void;
  onChangeChoiceGroup: (e, o) => void;
  filter: IRequetTableHistoricoPorSupervisor;
  limpiarFiltro: () => void;
  onSelectDate: (date, string) => void;
  fechasFilter: any;
}

export const PanelSupervisorHistorial = (props: IPanelSupervisorHistorial) => {
  const {
    SupervisoresCombo,
    _onkeyUpSearchSupervisores,
    comboBoxRefSupervisores,
    onClickComboSupevisores,
    obtenerPuesto,
  } = useComboSupervisores();
  const { estados } = useComboEstados();
  const {
    dataComboTipoEquipos,
    comboBoxRefTipoEquipo,
    onClickComboTipoEquipo,
    _onkeyUpSearchTipoEquipo,
  } = useComboTipoEquipo();

  const {
    dataComboModelos,
    onClickComboModelos,
    _onkeyUpSearchDispositivo,
    comboBoxRefModelos,
  } = useComboModelos();
  const {
    dataCombo,
    _onkeyUpSearchEquipo,
    comboBoxRefEquipoModelo,
    onChangeModelo,
    onClickCamboEquipo,
  } = useComboEquipos();

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={props.limpiarFiltro}
          disableButton={false}
          onDismiss={props.limpiarFiltro}
        />
      </>
    ),
    [props.onDismiss, props.limpiarFiltro]
  );
  
  const onRenderHeaderPanel = useCallback(
    () => (
      <PanelHeader
        textHeader="Filtro Avanzado Historial"
        subTextHeader={`Búsqueda Avanzada`}
      />
    ),
    []
  );

  return (
    <div>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onRenderFooter={onRenderHeaderPanel}
        onRenderHeader={onRenderFooterPanel}
        isFooterAtBottom={true}
        isBlocking={false}
        closeButtonAriaLabel="Close"
        type={PanelType.medium}
        isLightDismiss
      >
        <br />
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <DatePicker
                label="Fecha de:"
                placeholder="dd/mm/yyyy"
                ariaLabel="Seleccione una fecha"
                value={props.fechasFilter?.filterFechaInicio}
                onSelectDate={(date?: any) => {
                  props.onSelectDate(date, "inicio");
                }}
                formatDate={onFormatDate}
                maxDate={new Date()}
                underlined
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <DatePicker
                label="a:"
                placeholder="dd/mm/yyyy"
                ariaLabel="Seleccione una fecha"
                value={props.fechasFilter?.filterFechaFin}
                onSelectDate={(date?: any) => {
                  props.onSelectDate(date, "fin");
                }}
                formatDate={onFormatDate}
                maxDate={new Date()}
                underlined
              />
            </div>
          </div>
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <Label id="labelElement">
                <Stack horizontal verticalAlign="center">
                  <span>Estados&nbsp;&nbsp;</span>
                  <Icon iconName="Filter" />
                </Stack>
              </Label>
              <ChoiceGroup
                options={estados}
                selectedKey={props.filter?.estadoId}
                onChange={(e, o) => props.onChangeChoiceGroup(e, o)}
                ariaLabelledBy="labelElement"
              />
            </div>
          </div>
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Tipo Equipo:"
                componentRef={comboBoxRefTipoEquipo}
                selectedKey={props.filter?.tipoEquipoId}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "tipoEquipo");
                }}
                KeyUp={_onkeyUpSearchTipoEquipo}
                onClick={onClickComboTipoEquipo}
                options={dataComboTipoEquipos}
              />
            </div>
          </div>
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Modelo Equipo:"
                componentRef={comboBoxRefModelos}
                KeyUp={_onkeyUpSearchDispositivo}
                selectedKey={props.filter?.equipoModeloId}
                onClick={onClickComboModelos}
                options={dataComboModelos}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "modeloEquipo");
                  onChangeModelo(e, o);
                }}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Equipo:"
                componentRef={comboBoxRefEquipoModelo}
                KeyUp={_onkeyUpSearchEquipo}
                selectedKey={props.filter?.equipoId}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "equipo");
                }}
                onClick={onClickCamboEquipo}
                options={dataCombo}
              />
            </div>
          </div>
        </div>
      </Panel>
    </div>
  );
};
